export enum FUNDRAISER_COLUMNS {
    name = 'Name',
    email = 'Email',
    goal = 'Goal',
    teamId = 'Team Name',
}
